import { render, staticRenderFns } from "./manuallyAddRequirements.vue?vue&type=template&id=18e12d18&scoped=true&"
import script from "./manuallyAddRequirements.vue?vue&type=script&lang=js&"
export * from "./manuallyAddRequirements.vue?vue&type=script&lang=js&"
import style0 from "./manuallyAddRequirements.vue?vue&type=style&index=0&id=18e12d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e12d18",
  null
  
)

export default component.exports